<ul role="menu" class="menu-list">
  <ng-container *ngFor="let menuItem of menuItems">
    <li role="none" *ngIf="!menuItem.hidden" class="menu-list__item">
        <bulb-menu-item-action
            [menuItem]="menuItem"
            (menuItemClicked)="menuItemClicked.emit($event)">
        </bulb-menu-item-action>
    </li>
  </ng-container>
</ul>

<footer *ngIf="footerTemplate" class="menu-footer">
  <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
</footer>
